import { useMemo } from 'react';

import { useQuery } from '@apollo/client';

import { QUESTION_IDS } from 'bundles/onboarding-common/constants/questionScheme';
import LearnerObjectAttributesSkillsWantedQuery from 'bundles/onboarding-common/queries/LearnerObjectAttributesSkillsWanted.graphql';
import type { LearnerObjectAttributesSkillsWantedQuery as LearnerObjectAttributesSkillsWantedQueryType } from 'bundles/onboarding-common/queries/__generated__/LearnerObjectAttributesSkillsWanted';
import { formatSkillsWantedFromLearnerObject } from 'bundles/onboarding-common/utils/savedQuestionDataUtils';

const useLearnerObjectSkillsData = ({
  skip,
  filterUserGeneratedSkills = true,
}: {
  skip?: boolean;
  filterUserGeneratedSkills?: boolean;
}) => {
  const { data, loading, error } = useQuery<LearnerObjectAttributesSkillsWantedQueryType>(
    LearnerObjectAttributesSkillsWantedQuery,
    {
      context: { clientName: 'gatewayGql' },
      errorPolicy: 'all',
      fetchPolicy: 'network-only',
      skip,
    }
  );

  // Memoize the formatted value to prevent new references when data hasn't changed
  const value = useMemo(() => {
    return formatSkillsWantedFromLearnerObject(data, { filterUserGeneratedSkills });
  }, [data, filterUserGeneratedSkills]);

  return {
    value,
    loading,
    error,
    __typename: QUESTION_IDS.skillSelect,
  };
};

export default useLearnerObjectSkillsData;
